<template>
    <div class="our-loving-clients ptb-100 bg-f4f5fe">
        <div class="container">
            <div class="section-header" data-aos="fade-up">
                <span class="section-tag">Tech Stack</span>
                <h2>Unsere Technologien</h2>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="0">
                    <div class="tech-logo-box">
                        <VueDotjsIcon class="tech-icon" />
                        <span>Vue.js</span>
                    </div>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="100">
                    <div class="tech-logo-box">
                        <ReactIcon class="tech-icon" />
                        <span>React</span>
                    </div>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="200">
                    <div class="tech-logo-box">
                        <NodeDotjsIcon class="tech-icon" />
                        <span>Node.js</span>
                    </div>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="300">
                    <div class="tech-logo-box">
                        <GoIcon class="tech-icon" />
                        <span>GoLang</span>
                    </div>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="400">
                    <div class="tech-logo-box">
                        <TypeScriptIcon class="tech-icon" />
                        <span>TypeScript</span>
                    </div>
                </div>

                <div class="col-lg-2 col-md-3 col-sm-4 col-6" data-aos="zoom-in" data-aos-delay="500">
                    <div class="tech-logo-box">
                        <PostgreSqlIcon class="tech-icon" />
                        <span>PostgreSQL</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueDotjsIcon, ReactIcon, NodeDotjsIcon, TypeScriptIcon, PostgreSqlIcon, GoIcon } from 'vue3-simple-icons';

export default {
    name: 'OurLovingClients',
    components: {
        GoIcon,
        VueDotjsIcon,
        ReactIcon,
        NodeDotjsIcon,
        TypeScriptIcon,
        PostgreSqlIcon,
    }
}
</script>

<style scoped>
.tech-logo-box {
    text-align: center;
    padding: 25px 15px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 8px;
    transition: all 0.3s ease;
    /* box-shadow: 0 2px 10px rgba(0,0,0,0.05); */
}

.tech-logo-box:hover {
    transform: translateY(-5px);
    /* box-shadow: 0 5px 20px rgba(0,0,0,0.1); */
}

.tech-logo-box .tech-icon {
    width: 48px;
    height: 48px;
    fill: #010215;
    display: block;
    margin: 0 auto 10px auto;
}

.tech-logo-box span {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}
</style>